<organization-select    #orgManager
                        autoSelectFirst =   "true"
                        class           =   "mr-3"></organization-select>                        

<site-select            #siteManager
                        *ngIf           =   "orgManager"
                        [org]           =   "orgManager?.currentValue"
                        autoSelectFirst =   "true"
                        (change)        =   "siteChange($event)"
                        class           =   "mr-3"></site-select>

<br>

<help-alert text = "help.page.license.field" info = "help.info" description = "help.page.license.description"></help-alert>

<br>
<br>

<custom-table           #licenceTable
                        table_id            =   "licenceTable"
                        title_single        =   "tables.licences.title"
                        title_multiple      =   "tables.licences.title"
                        filter_title        =   "tables.licences.filter_title"
                        [filter_columns]    =   "false"
                        [buttons]           =   "buttons"
                        [header_buttons]    =   "header_buttons"
                        [columns]           =   "licenceColumns"
                        [values]            =   "licences"></custom-table>
                        <!--
                            [header_buttons]    =   "header_buttons"
                        -->
